import type { RoleEnum } from 'src/common/external/bambi-api/bambiApi';

export const rolesThatCanCreateTripsInThePast: RoleEnum[] = [
  'admin',
  'owner',
  'bambi',
];
